import React from 'react';

function Button(props: any) {

  return (
    <button type="submit" className="btn btn-primary" disabled={props.isSubmitting}>{props.children}</button>
  );
}

export default Button;